(function () {
    var model = angular.module('advanceSearchModule', []);

    model.controller(controllers.advanceSearchController, ['$scope', '$state', '$http', 'folderService', '$uibModalInstance', 'quickSearchKeyword', 'broadcastService', 'configService',
    function ($scope, $state, $http, folderService, $modalInstance, quickSearchKeyword, broadcastService, configService) {
        $scope.translation = globalResources;
        $scope.currentData = {
            advanceSearchKeyword: quickSearchKeyword,
            folderName: '',
            selectedDocType: 0,
            selectedFolderId: 0,
            datetime: {
                fromDate: null,
                toDate: null,
                isView: false
            },
            searchInContent: false,
            hasExpired: false
        };
        $scope.documentTypes = [];
        $scope.folderTree = [];
        $scope.filterOptionNeededMessage = globalResources.FilterOptionNeededMessage;
        $scope.showTreeDocument = false;
        $scope.key_showRemoveIcon = false;
        $scope.folder_showRemoveIcon = false;
        $scope.dateFrom_showRemoveIcon = false;
        $scope.dateTo_showRemoveIcon = false;

        $scope.initAdvanceSearchData = initAdvanceSearchData;
        $scope.onAdvanceSearch = onAdvanceSearch;
        $scope.close = close;
        $scope.loadFolderTree = loadFolderTree;
        $scope.hidePopupOnLostFocus = hidePopupOnLostFocus;
        $scope.selectNodeHead = selectNodeHead;
        $scope.selectNodeLabel = selectNodeLabel;
        $scope.hideTooltip = hideTooltip;
        $scope.clear_advKeyword = clear_advKeyword;
        $scope.clear_advFolder = clear_advFolder;
        $scope.clear_advDateFrom = clear_advDateFrom;
        $scope.clear_advDateTo = clear_advDateTo;
        $scope.showDocumentInTree = configService.getBool(HandbookConfiguration.ShowDocumentsInTree);

        function initAdvanceSearchData() {
            setTimeout(function () {
                $('#adv_keyword').focus();
            },1000);
            
            //Init chapter base on url
            var id = $state.params.folderId;
            if (id != undefined && id > 0 && $state.current.name == 'folder') {
                folderService.getFolderById(id).then(function (response) {
                    $scope.currentData.folderName = response.data.name;
                    $scope.currentData.selectedFolderId = response.data.id;
                });;
            }
            $scope.key_showRemoveIcon = ($scope.currentData.advanceSearchKeyword != undefined && $scope.currentData.advanceSearchKeyword.length > 0);
        };

        function onAdvanceSearch() {
            if ($scope.currentData.selectedFolderId != 0 || $scope.currentData.datetime.toDate != null || $scope.currentData.datetime.fromDate != null || $scope.currentData.advanceSearchKeyword != '') {
                $scope.filterOptionNeededMessage = '';
                $state.go(handbookActions.SearchResultAction, {
                    keyword: $scope.currentData.advanceSearchKeyword,
                    searchInContents: 1,
                    folderId: $scope.currentData.selectedFolderId,
                    fromDate: $scope.currentData.datetime.fromDate != null ? $scope.currentData.datetime.fromDate.getTime() : null,
                    toDate: $scope.currentData.datetime.toDate != null ? $scope.currentData.datetime.toDate.getTime() : null,
                    hasExpired: $scope.currentData.hasExpired ? 1: 0,
                    type: 3
                });
                $modalInstance.close(true);
                broadcastService(broadcastType.resetQuickSearchKeyword, null);
            }
            else {
                $scope.filterOptionNeededMessage = globalResources.FilterOptionNeededMessage;
            }
        };

        function close() {
            $modalInstance.close(true);
        }

        function loadFolderTree() {
            $scope.showTreeDocument = !$scope.showTreeDocument;
            if ($scope.showTreeDocument) {
                if ($scope.folderTree.length == undefined || $scope.folderTree.length == 0) {
                    $http.get(handbookRequests.GetFoldersRequest, { params: { 'Id': null, 'showDocumentInTree': $scope.showDocumentInTree } })
                         .success(function (data, status, headers, config) {
                             $scope.folderTree = data;
                         });
                }
            }
        };

        function hidePopupOnLostFocus() {
            $scope.showTreeDocument = false;
        };

        function selectNodeHead(node) {
            if (!node.isLoaded) {
                $http.get(handbookRequests.GetSubfoldersRequest, { params: { 'folderId': node.id } })
                    .success(function (data, status, headers, config) {
                        node.children = data;
                        node.isLoaded = true;
                    })
                    .error(function (data, status, headers, config) {
                        node.isLoaded = true;
                    });
            }
        };

        function selectNodeLabel(node) {
            $scope.currentData.folderName = node.name;
            $scope.currentData.selectedFolderId = node.id;
            $scope.folder_showRemoveIcon = ($scope.currentData.selectedFolderId != undefined && $scope.currentData.selectedFolderId > 0);
            folderService.setFolder(node);
            hidePopupOnLostFocus();
            hideTooltip();
        };

        $scope.$watch('currentData.datetime.fromDate', function () {
            if ($scope.currentData.datetime.fromDate != null) {
                hideTooltip();
                $scope.dateFrom_showRemoveIcon = ($scope.currentData.datetime.fromDate != undefined && $scope.currentData.datetime.fromDate != null);
            }
        });

        $scope.$watch('currentData.datetime.toDate', function () {
            if ($scope.currentData.datetime.toDate != null) {
                hideTooltip();
                $scope.dateTo_showRemoveIcon = ($scope.currentData.datetime.toDate != undefined && $scope.currentData.datetime.toDate != null);
            }
        });

        function hideTooltip() {
            if (angular.element('#btnAdvanceSearch').scope().tt_isOpen) {
                angular.element('#btnAdvanceSearch').scope().tt_isOpen = false;
            }
            $scope.key_showRemoveIcon = ($scope.currentData.advanceSearchKeyword != undefined && $scope.currentData.advanceSearchKeyword.length > 0);
        };

        function clear_advKeyword() {
            $scope.currentData.advanceSearchKeyword = '';
            $scope.key_showRemoveIcon = false;
        };

        function clear_advFolder() {
            $scope.currentData.folderName = '';
            $scope.currentData.selectedFolderId = 0;
            $scope.folder_showRemoveIcon = false;
        };

        function clear_advDateFrom() {
            $scope.currentData.datetime.fromDate = null;
            $scope.dateFrom_showRemoveIcon = false;
        };

        function clear_advDateTo() {
            $scope.currentData.datetime.toDate = null;
            $scope.dateTo_showRemoveIcon = false;
        };
    }]);

})();